import { IStatisticsGrid, StatisticsGrid } from "@sky-it-livedata/livedata-sports-design-system";
import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import transformer from "./transformQuery";
import { DriverStatisticsQuery } from "./types";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<IStatisticsGrid>) => {
  return { variables: JSON.stringify(variables) };
};

export function getServerProps({
  props,
}: WidgetContext<DriverStatisticsQuery>): IStatisticsGrid {
  return transformer(props);
}

export default function Statistics({
  props,
  tag,
  ...rest
}: WidgetContext<IStatisticsGrid>) {
  log({ props, tag, ...rest });

  return <StatisticsGrid {...props} />;
}
